const C = {
  name: "Coins",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.3346 6.00687C11.1562 3.67341 13.383 2 16 2C19.3123 2 22 4.68772 22 8C22 10.6208 20.3283 12.8397 17.993 13.6624C17.9977 13.7744 18 13.8869 18 14C18 18.4183 14.4183 22 10 22C5.58172 22 2 18.4183 2 14C2 9.58172 5.58172 6 10 6C10.1121 6 10.2236 6.00231 10.3346 6.00687ZM12.3499 6.35068C14.8775 7.12625 16.8722 9.12028 17.6485 11.6476C19.0373 11.019 20 9.62441 20 8C20 5.79228 18.2078 4 16 4C14.3766 4 12.9779 4.96602 12.3499 6.35068ZM11.0634 8.09394C10.7182 8.03222 10.3629 8 10 8C6.68629 8 4 10.6863 4 14C4 17.3137 6.68629 20 10 20C13.3137 20 16 17.3137 16 14C16 11.0751 13.9071 8.63905 11.1372 8.10763L11.0634 8.09394Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Coins
};
